import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import FeaturesListing from "@components/FeaturesListing/FeaturesListing";
import Breadcrumbs from "@components/Breadcrumbs/Breadcrumbs";
import Meta from "@components/Meta/Meta";
import { remAccents } from "@helpers/utils.js";

const ROOT = process.env.REACT_APP_CMS_STATIC;

function CreditosProductivosListado(props) {
  const [matches, setMatches] = useState([]);
  const [credsData, setCredsData] = useState([]);
  const [btnSoliciteCredito, setBtnSoliciteCredito] = useState("");

  const { rutas } = useSelector(({ Base }) => Base.ContenidoCMS);

  const { creditosProductivos } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito.AhorroYCredito
  );

  const defRoute = rutas?.filter(
    (route) => route?.name === "Creditos Productivos Listado"
  );

  const prevRoute = defRoute.map((route) => {
    return {
      url: route.url,
      text: route.h1,
    };
  });

  useEffect(() => {
    if (
      creditosProductivos &&
      creditosProductivos.aCBotonSoliciteSuCredito &&
      creditosProductivos.aCBotonSoliciteSuCredito[0]?.imagen
    ) {
      setBtnSoliciteCredito(
        creditosProductivos.aCBotonSoliciteSuCredito[0].imagen.urls[0]
      );
    }
    let promise = new Promise((resolve, reject) => {
      let productivos = creditosProductivos?.aCCreditosProductivos;
      let normalizeCreds =
        productivos &&
        productivos?.map((cred) => ({
          ...cred,
          nombre: remAccents((cred?.titulo).split(" ").join("").toLowerCase()),
          rutaPrevia: prevRoute,
        }));

      resolve(normalizeCreds);
    });

    promise.then((resultado) => setMatches(resultado));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [creditosProductivos]);

  useEffect(() => {
    const curSection =
      rutas && rutas.filter((uri) => uri.name === "CreditosProductivos");
    const rootUri = curSection && curSection[0]?.url;

    let items =
      matches &&
      matches.map((cred) => {
        const credUri =
          cred?.rutaPrevia[0]?.url + "/" + cred?.idCreditoProductivo;

        const botones = [
          {
            ruta: { url: credUri },
            imagen: { urls: [encodeURI("/CSCMS/media/Boton Mas Info.png")] },
          },
        ];
        cred?.urlformulariosolicitesucredito &&
          cred?.urlformulariosolicitesucredito.url &&
          btnSoliciteCredito &&
          botones.push({
            ruta: { url: cred?.urlformulariosolicitesucredito.url },
            imagen: { urls: [btnSoliciteCredito] },
          });
        return {
          title: cred?.titulo,
          image: ROOT + cred?.imagen.urls[0],
          url: rootUri.replace("/:id", "/" + cred.idCreditoProductivo),
          description: cred?.resumen?.html,
          buttons: botones,
        };
      });

    setCredsData(items);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matches, btnSoliciteCredito]);

  return (
    <div className="pt-5">
      <Meta
        title={defRoute[0]?.title}
        description={defRoute[0]?.description}
        canonicalUrl={defRoute[0]?.url}
      />
      <Breadcrumbs items={[]} active={defRoute[0]?.h1} />
      <h1 className="slogan">{defRoute[0].h1}</h1>
      <FeaturesListing features={credsData} />
    </div>
  );
}

export default CreditosProductivosListado;
